// SET_TEXT_FILTER
export const setTextFilter = (text = '') => ({
  type: 'SET_TEXT_FILTER',
  text
});

// SET_LABEL_FILTER
export const setLabelFilter = (label = '') => ({
  type: 'SET_LABEL_FILTER',
  label
});


// SORT_BY_DATE
export const sortByDate = () => ({
  type: 'SORT_BY_DATE'
});

// SORT_BY_DATE_DESCENDING
//sortByDateDescending
export const sortByDateDescending = () => ({
  type: 'SORT_BY_DATE_DESCENDING'
});




// SORT_BY_AMOUNT
export const sortByAmount = () => ({
  type: 'SORT_BY_AMOUNT'
});

// SET_START_DATE
export const setStartDate = (startDate) => ({
  type: 'SET_START_DATE',
  startDate
});

// SET_END_DATE
export const setEndDate = (endDate) => ({
  type: 'SET_END_DATE',
  endDate
});



// WEBPACK FOOTER //
// ./src/actions/filters.js